import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { styled } from '@linaria/react';
import { memo } from 'react';

type SectionProps = {
  title: string;
  RightContent?: React.ReactNode;
};

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-right: 24px;
  justify-content: space-between;
  position: relative;
`;

const Title = styled.h3`
  font-size: 22px;
  color: black;
  font-weight: 600;
  letter-spacing: 0.92px;
  padding-left: 21px;
  position: relative;
  line-height: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 30px;

  &::before {
    content: '';
    width: 5px;
    height: 22px;
    position: absolute;
    left: 0;
    top: 4px;
    background-color: #e03f19;
  }
`;

const TitleInfo = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    flex-direction: column;
    flex: 1;
  }
`;

export const Section = ({ title, RightContent }: SectionProps) => {
  return (
    <Container>
      <Title>
        <TitleInfo>{title}</TitleInfo>
      </Title>
      {RightContent && RightContent}
    </Container>
  );
};

export default memo(Section);
